// src/pages/JobDetailsPage.jsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

import "./JobsInternshipPage.css"; // reuse existing CSS

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

// Helper to format dates
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export default function JobDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch job by ID from backend
  useEffect(() => {
    const fetchJob = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE_URL}/jobs/${id}`);
        if (res.data) setJob(res.data);
      } catch (err) {
        console.error("Failed to fetch job:", err.message);
        setError("Failed to load job data.");
      } finally {
        setLoading(false);
      }
    };
    fetchJob();
  }, [id]);

  if (loading) return <div className="jobs-container">Loading job data…</div>;
  if (error) return <div className="jobs-container jobs-error">{error}</div>;
  if (!job) return <div className="jobs-container">Job not found.</div>;

  return (
    <div className="jobs-container">
      {/* Back Button */}
      <motion.button
        className="back-button"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => navigate(-1)}
        style={{ marginBottom: "20px" }}
      >
        ← Back
      </motion.button>

      <h1 className="job-title">{job.title}</h1>

      <p className="job-meta">
        {job.company} • {job.location} • {job.type}
      </p>

      <p className="job-deadline">
        Application Deadline: {formatDate(job.deadline)}
      </p>

      <section className="job-section">
        <h2>Job Summary</h2>
        <p>{job.summary}</p>
      </section>

      <section className="job-section">
        <h2>Job Description</h2>
        <p>{job.description}</p>
      </section>

      <section className="job-section">
        <h2>Responsibilities</h2>
        <ul>
          {job.responsibilities?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="job-section">
        <h2>Requirements</h2>
        <ul>
          {job.requirements?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="job-section">
        <h2>How to Apply</h2>
        {job.applyType === "external" && job.applyLink ? (
          <a
            href={job.applyLink}
            target="_blank"
            rel="noreferrer"
            className="card-button"
          >
            Apply on Company Website
          </a>
        ) : (
          <p>
            Send your CV and cover letter to:
            <strong> {"info@ugaaliberia.org"}</strong>
          </p>
        )}
      </section>

      
    </div>
  );
}
